export class QualityAssuranceFileUploadsModel {
    constructor() {
        this.entityId = null;
        this.examType = null;
        this.examProducts = [];
        this.virtualExamDate = null;
    }
}
